document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('cart-icon-bubble')) return;
  async function refreshCartBubble() {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      const cart = await response.json();
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      let countBubble = bubble.querySelector('.cart-count-bubble');

      if (cart.item_count > 0) {
        if (!countBubble) {
          countBubble = document.createElement('div');
          countBubble.className = 'cart-count-bubble';
          bubble.appendChild(countBubble);
        }

        countBubble.innerHTML = `
          ${cart.item_count < 100 ? `<span aria-hidden="true">${cart.item_count}</span>` : ''}
          <span class="visually-hidden">Panier, ${cart.item_count} article${cart.item_count > 1 ? 's' : ''}</span>
        `;
      } else if (countBubble) {
        countBubble.remove();
      }
    } catch (error) {
      console.error('Erreur mise à jour compteur panier :', error);
    }
  }

  refreshCartBubble();

  window.addEventListener('pageshow', function () {
    refreshCartBubble();
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
      setTimeout(refreshCartBubble, 500);
      setTimeout(refreshCartBubble, 1000);
  });

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[name="add"], .quick-add__submit');
    if (btn) {
      setTimeout(refreshCartBubble, 500);
      setTimeout(refreshCartBubble, 1000);
      return;
    }

    const removeBtn = event.target.closest('cart-remove-button a, cart-remove-button button, .cart__remove, [href*="/cart/change"], [name="updates[]"]');
    if (removeBtn) {
      setTimeout(refreshCartBubble, 500);
      setTimeout(refreshCartBubble, 1000);
    }
  });

  document.addEventListener('change', function (event) {
    const qtyInput = event.target.closest('input[name="updates[]"], .quantity__input');
    if (!qtyInput) return;
    setTimeout(refreshCartBubble, 500);
    setTimeout(refreshCartBubble, 1000);
  });
});